/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Application, Assets, Container, Sprite, Text, TextureStyle } from 'pixi.js';
import { OverlayTexture } from './Textures';
import { OverlayOptions, OverlayCanvasOptions } from './Types';

/*
|--------------------------------------------------------------------------
| Exports
|--------------------------------------------------------------------------
*/

export { OverlayTexture, OverlayOptions, OverlayCanvasOptions }

/*
|--------------------------------------------------------------------------
| Configure Pixi
|--------------------------------------------------------------------------
*/

TextureStyle.defaultOptions.scaleMode = 'nearest';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _pixi: Application = null;

/*
|--------------------------------------------------------------------------
| Private Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {HTMLCanvasElement}
 */
function _getCanvas(options?: string | OverlayCanvasOptions): HTMLCanvasElement
{
    if (options === null || options === undefined) {
        return document.getElementById('2d') as HTMLCanvasElement;
    } else if (typeof options === 'string') {
        return document.getElementById(options) as HTMLCanvasElement;
    } else {
        return document.getElementById(options.id) as HTMLCanvasElement;
    }
}

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function OverlayAdd(object: Container | Sprite | Text): void
{
    _pixi.stage.addChild(object);
}

/**
 * @return {void}
 */
export function OverlayRemove(container: Container): void
{
    _pixi.stage.removeChild(container);
}

/**
 * @return {void}
 */
export function OverlayRemoveAll(): void
{
    let index = _pixi.stage.children.length;

    while (index--) {
        _pixi.stage.removeChildAt(index);
    }
}

/**
 * @return {Promise<void>}
 */
export function OverlayLoadAssets(): Promise<void>
{
    return new Promise((resolve): void => {
        let remaining = 2;
        let onLoaded = (): void => {
            if (--remaining === 0) {
                resolve();
            }
        };

        Assets.load('/2d/spritesheet.json').then(onLoaded);
        Assets.load('/2d/spritesheet.png').then(onLoaded);
    });
}

/**
 * @return {Promise<void>}
 */
export async function OverlayInit(options?: OverlayOptions): Promise<void>
{
    _pixi = new Application;

    await _pixi.init({
        width: window.innerWidth,
        height: window.innerHeight,
        backgroundAlpha: 0,
    });

    _pixi.canvas.style.pointerEvents = 'none';
    _pixi.canvas.style.position = 'absolute';
    _pixi.canvas.style.top = '0';
    _pixi.canvas.style.left = '0';
    _pixi.canvas.style.width = '100vw';
    _pixi.canvas.style.height = '100vh';

    document.body.appendChild(_pixi.canvas);
}
